import React from "react";
import "./Solar_Power.css";

import { SolarPowers } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Solar_Power = () => {
  const solarData = [
    {
      title: "Birthday Celebration",
      span: "  ",
      text:
        "Make every birthday unforgettable with vibrant themes, creative décor, and joyful moments. From kids’ parties to milestone celebrations, we plan every detail to perfection so you can enjoy your special day stress-free.",
      img: "/assets/images/home/solar_power/img-1.png",
    },
    {
      title: "Engagement Ceremony",
      span: "  ",
      text:
        "Celebrate the beginning of your forever with a beautifully planned engagement ceremony. We create elegant setups, romantic ambiance, and memorable experiences that reflect your unique love story.",
      img: "/assets/images/home/solar_power/img-2.png",
    },
    {
      title: "Baby Shower",
      span: " Commercial & Industrial",
      text:
        "Welcome your little bundle of joy with a heartwarming baby shower celebration. From adorable themes to thoughtful arrangements, we ensure a delightful and memorable experience for you and your loved ones.",
      img: "/assets/images/home/solar_power/img-3.png",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [solarpower, setSolarPower] = useState([]);

  const getSolarPowers = async () => {
    const res = await SolarPowers();
    if (res?.success) {
      setSolarPower(res.data);
    }
  };
  useEffect(() => {
    getSolarPowers();
  }, []);

  return (
    <section className="Solar_Power">
      <div className="container">
        <div className="section_header_holder">
          <h5 className="section_title">
            Built to make your event journey smoother
          </h5>
          <p className="section_subtitle">
            Customized and budget-friendly event planning services designed for
            weddings, parties, and corporate gatherings.
          </p>
        </div>

        <div className="solar_card_div">
          <div className="row justify-content-center">
            {solarpower.map((item, index) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-5 mt-1"
                key={index}
              >
                <div className="solar_box">
                  <div className="solar_content">
                    <h5 className="card_title">{item.name}</h5>
                    <p className="card_span">{item.subtitle}</p>
                    <p className="card_text">
                      {htmlToReactParser.parse(item.description)}
                    </p>
                  </div>
                  <div className="solar_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item.title}
                      className="solar_img"
                    />
                  </div>

                  {/* <div className="card_btn_holder">
                    <button className="card_btn">Explore Now</button>{" "}
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solar_Power;
